import { render, staticRenderFns } from "./todosDetail.vue?vue&type=template&id=6071192b&"
import script from "./todosDetail.vue?vue&type=script&lang=js&"
export * from "./todosDetail.vue?vue&type=script&lang=js&"
import style0 from "./todosDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports